<script>

import {mapActions, mapState} from "vuex";
import MemoBlock from "@/driver/pages/orders/accepts/collection/blocks/_Memo.vue";
import TransportRouteResult from "@/driver/components/TransportRouteResult.vue";
export default {
  name: "ShowEntryPatternModal",
  components: {
    TransportRouteResult,
    MemoBlock,
  },
  props: {
    enable: {
      type: Boolean,
      default: false,
    },
    emissionId: {
      type: Number,
      default: null,
    },
    targetId: {
      type: Number,
      default: null,
    },
    orderType: {
      type: String,
      default: "collection"
    }
  },
  data () {
    return {
      key: 0,
      buttonLocked: false,
      order: null,
      selectedTab: 0,
      entryPattern: {},
      recycleDisposerDisposalMethodDetailHeaders: [
        { value: "after_disposal_method", text: "処分方法", width: "15%" },
        { value: "before_disposal_weight", text: "処分割合", width: "10%" },
        { value: "after_disposal_item", text: "処理後物の大分類\r\n処理後物の種類", width: "20%" },
        { value: "after_disposal_weight", text: "処理後割合", width: "10%" },
        { value: "final_disposal", text: "最終処分", width: "8%" },
      ],
    }
  },
  watch: {
    enable (newValue) {
      this.order = null;
      this.selectedTab = 0;
      if (newValue) {
        this.key += 1;

        this.loadEntryPattern();
      }
    },
  },
  computed: {
    ...mapState('DriverTenantConfiguration', {
      isBilling: 'use_billing',
    }),
  },
  created() {
  },
  methods: {
    ...mapActions("DriverMasterEmissionEntryPattern", {
      fetchEntryPattern: "show"
    }),
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('closeCallback');
    },
    loadEntryPattern () {
      this.fetchEntryPattern({ emission_id: this.emissionId, id: this.targetId }).then((content) => {
        this.entryPattern = content.entry_pattern;
        this.order = content;
      })
    },
  },

}
</script>

<template>
  <div>
    <v-dialog
      :value="enable"
      fullscreen
      persistent
      scrollable
      transition="dialog-bottom-transition"
      @keydown.esc="closeButtonClickEvent"
      @close="closeButtonClickEvent"
    >
      <v-card flat>
        <v-toolbar
          flat
          class="primary white--text"
          style="flex: initial"
        >
          <v-toolbar-title>
            登録パターン
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn
              icon
              dark
              @click="closeButtonClickEvent"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text>
          <v-container
            v-if="order"
          >
            <v-card flat>
              <!-- パターン名, デフォルト(登録テンプレート編集用) -->
              <v-card-text>
                <v-row>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <div class="overline">
                      排出事業者
                    </div>
                    <h4 class="font-weight-medium">
                      {{ entryPattern.emission_name }}&nbsp;
                    </h4>
                    <v-divider />
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="overline">
                      排出事業場
                    </div>
                    <h4 class="font-weight-medium">
                      <span v-if="entryPattern.is_shared">
                        -
                      </span>
                      <span v-else>
                        {{ entryPattern.location_name }}
                      </span>
                      &nbsp;
                    </h4>
                    <v-divider />
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                  >
                    <div class="overline text-right">
                      表示順
                    </div>
                    <h4 class="font-weight-medium text-right">
                      {{ entryPattern.sort_priority }}&nbsp;
                    </h4>
                    <v-divider />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="4">
                    <div class="overline">
                      パターン名
                    </div>
                    <h4 class="font-weight-medium">
                      {{ entryPattern.name }}&nbsp;
                    </h4>
                    <v-divider />
                  </v-col>
                  <v-col cols="12" md="8">
                    <v-radio-group
                      row
                      hide-details="auto"
                      class="mt-3 mb-0"
                    >
                      <v-checkbox
                        v-model="entryPattern.is_shared"
                        :class="{ 'ml-5': $vuetify.breakpoint.smAndUp }"
                        :ripple="false"
                        class="mt-0 mb-0"
                        hide-details="auto"
                        label="事業場共通として利用する"
                        readonly
                      />
                    </v-radio-group>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-divider />
              <!-- /パターン名, デフォルト(登録テンプレート編集用) -->

              <v-card-title class="px-0">
                <v-row dense>
                  <v-col cols="12" md="6">
                    <v-btn
                      color="primary"
                      block
                      large
                      elevation="0"
                      :ripple="false"
                      value="master"
                    >
                      マスタから登録
                    </v-btn>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-btn
                      block
                      disabled
                      large
                      elevation="2"
                      value="free"
                    >
                      フリー登録
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-title>

              <!-- 売上計上しない, 営業担当者, DXE起票担当者 -->
              <v-card-text>
                <!-- 売上計上しない -->
                <v-row
                  v-if="isBilling"
                >
                  <v-col cols="12" md="3">
                    <v-checkbox
                      v-model="order.not_recorded_sales"
                      dense
                      disabled
                      label="売上計上しない"
                      hide-details="auto"
                    />
                  </v-col>
                </v-row>
                <!-- /売上計上しない -->
                <!-- 営業担当者, DXE起票担当者 -->
                <v-row>
                  <v-col cols="12" md="6">
                    <div class="overline">
                      営業担当者
                    </div>
                    <h4>{{ order.sales_staff }}</h4>
                    <v-divider />
                  </v-col>
                  <v-col cols="12" md="6">
                    <div class="overline">
                      DXE起票担当者
                    </div>
                    <h4>{{ order.dxe_vote_staff }}</h4>
                    <v-divider />
                  </v-col>
                </v-row>
                <!-- /営業担当者, DXE起票担当者 -->
              </v-card-text>
              <!-- /売上計上しない, 営業担当者, DXE起票担当者 -->

              <!-- 排出事業者情報 -->
              <v-card-text>
                <v-row dense>
                  <v-col cols="12" md="6">
                    <h2 class="font-weight-light " style="color: #0074BA;height: 25px;">排出事業者情報</h2>
                    <!-- 会社名 -->
                    <v-row dense>
                      <v-col cols="12">
                        <div class="overline">
                          会社名
                        </div>
                        <h4>{{ order.emission.name }}</h4>
                        <v-divider />
                      </v-col>
                    </v-row>
                    <!-- /会社名 -->
                    <!-- 住所 -->
                    <v-row dense>
                      <v-col cols="12">
                        <div class="overline">
                          住所
                        </div>
                        <div>
                          <h4>〒{{ order.emission.zip_code }}</h4>
                        </div>
                        <div>
                          <h4>{{ order.emission.address }}</h4>
                        </div>
                        <v-divider />
                      </v-col>
                    </v-row>
                    <!-- /住所 -->

                    <!-- 電話番号 -->
                    <v-row dense>
                      <v-col cols="12">
                        <div class="overline">
                          電話番号
                        </div>
                        <h4>{{ order.emission.phone_number || '-' }}</h4>
                        <v-divider />
                      </v-col>
                    </v-row>
                    <!-- /電話番号 -->
                  </v-col>
                  <v-col cols="12" md="6">
                    <h2 class="font-weight-light" style="color: #0074BA;height: 25px;">
                      排出事業場情報
                      &emsp;
                      <v-checkbox
                        v-model="order.use_spot_emission_location"
                        disabled
                        dense
                        hide-details="auto"
                        class="mt-0"
                        small
                        label="スポット排出事業場"
                        style="display: inline-block"
                      />
                    </h2>
                    <!-- 事業場名 -->
                    <v-row dense>
                      <v-col cols="12">
                        <div class="overline">
                          事業場名
                        </div>
                        <h4>{{ order.emission_location.name }}</h4>
                        <v-divider />
                      </v-col>
                    </v-row>
                    <!-- /事業場名 -->
                    <!-- 事業場住所 -->
                    <v-row dense>
                      <v-col cols="12">
                        <div class="overline">
                          住所
                        </div>
                        <div>
                          <h4>〒{{ order.emission_location.zip_code }}</h4>
                        </div>
                        <div>
                          <h4>{{ order.emission_location.address }}</h4>
                        </div>
                        <v-divider />
                      </v-col>
                    </v-row>
                    <!-- /事業場住所 -->
                    <!-- 電話番号 -->
                    <v-row dense>
                      <v-col cols="12">
                        <div class="overline">
                          電話番号
                        </div>
                        <h4>{{ order.emission_location.phone_number || '-' }}</h4>
                        <v-divider />
                      </v-col>
                    </v-row>
                    <!-- /電話番号 -->
                  </v-col>
                </v-row>
              </v-card-text>
              <!-- /排出事業者情報 -->

              <!-- 希望時間 -->
              <v-card-title>
                <span style="color: #0074BA">回収日</span>&emsp;
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="3">
                    <div class="overline">
                      回収日
                    </div>
                    <h4>
                      {{ order.collected_date }}&nbsp;
                      &nbsp;
                    </h4>
                    <v-divider />
                  </v-col>
                  <v-col cols="12" md="3">
                    <div class="overline">
                      希望時間
                    </div>
                    <h4>
                      <span v-if="order.preferred_start_time || order.preferred_end_time">
                        {{ order.preferred_start_time | from_to_linked_time(order.preferred_end_time, ' 〜 ') }}&nbsp;
                      </span>
                      &nbsp;
                    </h4>
                    <v-divider />
                  </v-col>
                </v-row>
              </v-card-text>
              <!-- /希望時間 -->

              <v-row v-if="false" align="center">
                <v-checkbox
                  v-model="entryPattern.use_collection_date_offset"
                  disabled
                  hide-details="auto"
                  class="shrink mt-0 pl-2 disabled"
                />
                <span style="font-size: 16px; min-height: 8px;">登録日の</span>
                <div style="width: 5rem" class="ml-1 mr-1">
                  <v-select
                    v-model="entryPattern.collection_date_offset_days"
                    :items="[0,1,2,3]"
                    disabled
                    dense
                    hide-details="auto"
                    outlined
                  >
                  </v-select>
                </div>
                <span style="font-size: 16px; min-height: 8px;">日前を表示する。</span>
              </v-row>

              <!-- 検索キーワード -->
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="6">
                    <div class="overline">
                      検索キーワード
                    </div>
                    <h4>
                      {{ order.keyword || '-' }}&nbsp;
                    </h4>
                    <v-divider />
                  </v-col>
                </v-row>

              </v-card-text>
              <!-- 検索キーワード -->

              <!-- 連絡事項 -->
              <memo-block :collection-request="order" />
              <!-- 連絡事項 -->

              <!-- マニフェスト区分, 引渡担当者, 登録担当者, 運搬担当者, 運搬方法, 車両番号 -->
              <v-card-title>
                <span style="color: #0074BA">マニフェスト</span>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="3">
                    <div class="overline">
                      マニフェスト区分
                    </div>
                    <h4>{{ order.manifest_type | manifest_type_to_label }}&nbsp;</h4>
                    <v-divider />
                  </v-col>
                </v-row>

                <!-- 引渡担当者/登録担当者 -->
                <v-row>
                  <v-col cols="12" md="4">
                    <div class="overline">
                      引渡担当者
                    </div>
                    <h4>{{ order.deliver_staff }}&nbsp;</h4>
                    <v-divider />
                  </v-col>
                  <v-col cols="12" md="4">
                    <div class="overline">
                      登録担当者
                    </div>
                    <h4>{{ order.register_staff }}&nbsp;</h4>
                    <v-divider />
                  </v-col>
                </v-row>
                <!-- /引渡担当者/登録担当者 -->

                <!-- 運搬担当者／運搬方法／車両番号 -->
                <v-row>
                  <v-col cols="12" md="4">
                    <div class="overline">
                      運搬担当者
                    </div>
                    <h4>{{ order.transport_user_name }}&nbsp;</h4>
                    <v-divider />
                  </v-col>

                  <v-col cols="12" md="4">
                    <div class="overline">
                      運搬方法
                    </div>
                    <h4>{{ order.transportation_name }}&nbsp;</h4>
                    <v-divider />
                  </v-col>

                  <v-col cols="12" md="4">
                    <div class="overline">
                      車両番号
                    </div>
                    <h4>{{ order.vehicle_number }}&nbsp;</h4>
                    <v-divider />
                  </v-col>
                </v-row>
                <!-- /運搬担当者／運搬方法／車両番号 -->
              </v-card-text>
              <!-- マニフェスト区分, 引渡担当者, 登録担当者, 運搬担当者, 運搬方法, 車両番号 -->

              <v-tabs
                v-model="selectedTab"
                show-arrows
                align-with-title

                background-color="blue-grey lighten-4"
              >
                <v-tabs-slider />
                <v-tab
                  v-for="manifest in order.manifests"
                  :key="manifest.key"
                  ripple
                >
                  {{ manifest.item_name || '未設定' }}
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="selectedTab">
                <v-tab-item
                  v-for="(manifest) in order.manifests"
                  :key="manifest.key"
                >
                  <v-card>
                    <v-card-text>
                      <!-- マニフェスト番号 -->
                      <v-row
                        v-if="manifest.manifest_type !== 'dxe_form' || order.order_type === 'general'"
                      >
                        <v-col
                          cols="12"
                          md="4"
                        >
                          <div class="overline">
                            マニフェスト番号
                          </div>
                          <h4>{{ manifest.manifest_no }}&nbsp;</h4>
                          <v-divider />
                        </v-col>
                      </v-row>
                      <!-- /マニフェスト番号 -->

                      <!-- 売上品目, 取扱品目, 廃棄物の名称 -->
                      <v-row>
                        <v-col
                          v-if="isBilling && order.order_type !== 'general'"
                          cols="12"
                          md="4"
                        >
                          <div class="overline">
                            売上品目
                          </div>
                          <h4>{{ manifest.sales_item_price_name }}&nbsp;</h4>
                          <v-divider />
                        </v-col>
                        <v-col cols="12" md="4">
                          <div class="overline">
                            {{order.order_type === 'general' ? '一般廃棄物品目' : '取扱品目'}}
                          </div>
                          <h4>{{ manifest.item_name }}&nbsp;</h4>
                          <v-divider />
                        </v-col>
                        <v-col cols="12" md="4">
                          <div class="overline">
                            廃棄物の名称
                          </div>
                          <h4>{{ manifest.waste_name }}&nbsp;</h4>
                          <v-divider />
                        </v-col>
                      </v-row>
                      <!-- /売上品目, 取扱品目, 廃棄物の名称 -->

                      <!-- 数量／数量単位 -->
                      <v-row>
                        <v-col cols="12" md="3">
                          <div class="overline text-right">
                            数量
                          </div>
                          <h4 class="text-right">{{ manifest.quantity }}&nbsp;</h4>
                          <v-divider />
                        </v-col>
                        <v-col cols="12" md="3">
                          <div class="overline">
                            数量単位
                          </div>
                          <h4>{{ manifest.quantity_unit_name }}&nbsp;</h4>
                          <v-divider />
                        </v-col>
                        <v-col cols="12" md="6">
                          <div class="overline">
                            数量の確定者
                          </div>
                          <h4>{{ manifest.quantity_confirm_name }}&nbsp;</h4>
                          <v-divider />
                        </v-col>
                      </v-row>
                      <!-- /数量／数量単位 -->

                      <!-- 荷姿／荷姿数量 -->
                      <v-row>
                        <v-col cols="12" md="6">
                          <div class="overline">
                            荷姿
                          </div>
                          <h4>{{ manifest.packing_name }}&nbsp;</h4>
                          <v-divider />
                        </v-col>
                        <v-col cols="12" md="6">
                          <div class="overline">
                            荷姿の数量
                          </div>
                          <h4 class="text-right">{{ manifest.packing_quantity }}&nbsp;</h4>
                          <v-divider />
                        </v-col>
                      </v-row>
                      <!-- /荷姿／荷姿数量 -->

                      <!-- 有害物質 -->
                      <template v-if="manifest.use_harmful">
                        <v-row>
                          <v-col cols="12" md="6">
                            <div class="overline">
                              有害物質1
                            </div>
                            <h4>{{ manifest.hazardous_substance_1_name }}&nbsp;</h4>
                            <v-divider />
                          </v-col>
                          <v-col cols="12" md="6">
                            <div class="overline">
                              有害物質2
                            </div>
                            <h4>{{ manifest.hazardous_substance_2_name }}&nbsp;</h4>
                            <v-divider />
                          </v-col>
                          <v-col cols="12" md="6">
                            <div class="overline">
                              有害物質3
                            </div>
                            <h4>{{ manifest.hazardous_substance_3_name }}&nbsp;</h4>
                            <v-divider />
                          </v-col>
                          <v-col cols="12" md="6">
                            <div class="overline">
                              有害物質4
                            </div>
                            <h4>{{ manifest.hazardous_substance_4_name }}&nbsp;</h4>
                            <v-divider />
                          </v-col>
                          <v-col cols="12" md="6">
                            <div class="overline">
                              有害物質5
                            </div>
                            <h4>{{ manifest.hazardous_substance_5_name }}&nbsp;</h4>
                            <v-divider />
                          </v-col>
                          <v-col
                            cols="12"
                            md="6"
                          >
                            <div class="overline">
                              有害物質6
                            </div>
                            <h4>{{ manifest.hazardous_substance_6_name }}&nbsp;</h4>
                            <v-divider />
                          </v-col>
                        </v-row>
                      </template>
                      <!-- /有害物質 -->

                      <!-- ルート一覧 -->
                      <h3 class="font-weight-thin mb-2 mt-3 ml-2">運搬ルート</h3>
                      <v-row>
                        <v-col>
                          <div class="overline">
                            運搬ルート名
                          </div>
                          <h4>{{ manifest.transport_route_name }}&nbsp;</h4>
                          <v-divider />

                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <!-- ルート詳細 -->
                          <transport-route-result
                            :custom-mode="true"
                            :emission="order.emission"
                            :form="manifest"
                            :transport-route-id="manifest.transport_route_id"
                          />
                          <!-- /ルート詳細 -->

                        </v-col>
                      </v-row>
                      <!-- /ルート一覧 -->

                      <!-- 処分方法 -->
                      <v-row>
                        <v-col cols="12" md="6">
                          <div class="overline">
                            処分方法
                          </div>
                          <h4>{{ manifest.disposal_method_name }}&nbsp;</h4>
                          <v-divider />
                        </v-col>
                      </v-row>
                      <!-- /処分方法 -->

                      <!-- 再資源化　基準重量・処分場処理方法 -->
                      <v-row>
                        <v-col cols="12" md="6">
                          <div class="overline">
                            基準重量
                          </div>
                          <h4>{{ manifest.standard_quantity_type_name }}&nbsp;</h4>
                          <v-divider />
                        </v-col>

                        <v-col cols="12" md="6">
                          <div class="overline">
                            処分場処理方法
                          </div>
                          <h4>{{ manifest.recycle_disposer_disposal_method_name }}&nbsp;</h4>
                          <v-divider />
                        </v-col>
                      </v-row>
                      <!-- /再資源化　基準重量・処分場処理方法 -->

                      <v-row>
                        <v-col cols="10">
                          <v-data-table
                            :headers="recycleDisposerDisposalMethodDetailHeaders"
                            :items=manifest.recycle_disposer_disposal_method_details
                            :items-per-page="-1"
                            class="elevation-0"
                            disable-sort
                            hide-default-footer
                          >
                            <template v-slot:[`header.after_disposal_item`]>処理後物の大分類名<br>処理後物の種類</template>

                            <template v-slot:[`item.after_disposal_method`]="{ item }">
                              <div>{{ item.after_disposal_method }}</div>
                              <div>{{ item.after_disposal_method_names.join('/') }}</div>
                            </template>

                            <template v-slot:[`item.before_disposal_weight`]="{ item }">
                              <div>{{ item.before_disposal_weight }}&#37;</div>
                            </template>

                            <template v-slot:[`item.after_disposal_item`]="{ item }">
                              <div>{{ item.after_disposal_item_parent_name }}</div>
                              <div>{{ item.after_disposal_item_name }}</div>
                            </template>

                            <template v-slot:[`item.after_disposal_weight`]="{ item }">
                              <div>{{ item.after_disposal_weight }}&#37;</div>
                            </template>

                            <template v-slot:[`item.final_disposal`]="{ item }">
                              <div class="d-flex justify-center">
                                <v-simple-checkbox
                                  :value="item.final_disposal"
                                  disabled
                                />
                              </div>
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>


                      <!-- 連絡番号 -->
                      <v-row>
                        <v-col cols="12" md="6" class="pa-0">
                          <v-row>
                            <v-col cols="12">
                              <div class="overline">
                                連絡番号１
                              </div>
                              <h4>{{ manifest.contact_number_1 }}&nbsp;</h4>
                              <v-divider />
                            </v-col>
                          </v-row>
                          <v-row v-if="manifest.contact_number_2">
                            <v-col cols="12">
                              <div class="overline">
                                連絡番号２
                              </div>
                              <h4>{{ manifest.contact_number_2 }}&nbsp;</h4>
                              <v-divider />
                            </v-col>
                          </v-row>
                          <v-row v-if="manifest.contact_number_3">
                            <v-col cols="12">
                              <div class="overline">
                                連絡番号３
                              </div>
                              <h4>{{ manifest.contact_number_3 }}&nbsp;</h4>
                              <v-divider />
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12" md="6" class="pa-0">
                          <v-row>
                            <v-col cols="12">
                              <div class="overline">
                                備考１
                              </div>
                              <h4>{{ manifest.note_1 }}&nbsp;</h4>
                              <v-divider />
                            </v-col>
                          </v-row>
                          <v-row v-if="manifest.note_2">
                            <v-col cols="12">
                              <div class="overline">
                                備考２
                              </div>
                              <h4>{{ manifest.note_2 }}&nbsp;</h4>
                              <v-divider />
                            </v-col>
                          </v-row>
                          <v-row v-if="manifest.note_3">
                            <v-col cols="12">
                              <div class="overline">
                                備考３
                              </div>
                              <h4>{{ manifest.note_3 }}&nbsp;</h4>
                              <v-divider />
                            </v-col>
                          </v-row>

                          <v-row v-if="manifest.note_4">
                            <v-col cols="12">
                              <div class="overline">
                                備考４
                              </div>
                              <h4>{{ manifest.note_4 }}&nbsp;</h4>
                              <v-divider />
                            </v-col>
                          </v-row>
                          <v-row v-if="manifest.note_5">
                            <v-col cols="12">
                              <div class="overline">
                                備考５
                              </div>
                              <h4>{{ manifest.note_5 }}&nbsp;</h4>
                              <v-divider />
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                      <!-- /連絡番号 -->

                      <!-- マニフェスト検索キーワード -->
                      <v-row>
                        <v-col cols="12" md="6">
                          <div class="overline">
                            マニフェスト検索キーワード
                          </div>
                          <h4>{{ manifest.manifest_search_keyword }}&nbsp;</h4>
                          <v-divider />
                        </v-col>
                      </v-row>
                      <!-- /マニフェスト検索キーワード -->

                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-card>

          </v-container>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            class="mr-15"
            @click="closeButtonClickEvent"
          >
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
